import { IVehicle } from "./type";

const __REPAIR_CURRENT_VEHICLE__ = "__REPAIR_CURRENT_VEHICLE__";

const useCurrentVeichle = () => {
  const veichle: string | null = window.sessionStorage.getItem(
    __REPAIR_CURRENT_VEHICLE__
  );

  const currentVeichle = veichle ? JSON.parse(veichle) : null;

  const handleCurrentVeichle = (veichle: IVehicle) => {
    window.sessionStorage.setItem(
      __REPAIR_CURRENT_VEHICLE__,
      JSON.stringify(veichle)
    );
  };

  return { currentVeichle, handleCurrentVeichle };
};

export default useCurrentVeichle;
